(() => {
  /* ---------- Tab navigation (home page) ---------- */
  const tablist = document.querySelector('.tabs');
  if (tablist) {
    const tabs = [...tablist.querySelectorAll('[role="tab"]')];
    const panels = [...document.querySelectorAll('.page > [role="tabpanel"]')];

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab)));

    tablist.addEventListener('keydown', (event) => {
      const currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex < 0) return;

      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = tabs.length - 1;
      else return;

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    });

    /* Landing marquee opens the portfolio tab */
    const landingWork = document.getElementById('landing-work');
    if (landingWork) {
      const openPortfolio = () => {
        const portfolioTab = document.getElementById('tab-portfolio');
        if (portfolioTab) {
          activateTab(portfolioTab);
          portfolioTab.scrollIntoView({ block: 'start' });
        }
      };
      landingWork.addEventListener('click', openPortfolio);
      landingWork.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openPortfolio();
        }
      });
    }

    /* Landing "Merch" card opens the merch tab */
    const landingMerch = document.getElementById('landing-merch-link');
    if (landingMerch) {
      landingMerch.addEventListener('click', (event) => {
        event.preventDefault();
        const merchTab = document.getElementById('tab-merch');
        if (merchTab) {
          activateTab(merchTab);
          merchTab.scrollIntoView({ block: 'start' });
        }
      });
    }

    /* Merch sub tabs */
    const merchTablist = document.querySelector('.merch-tabs');
    let activateMerchTab = null;
    if (merchTablist) {
      const merchTabs = [...merchTablist.querySelectorAll('[role="tab"]')];
      const merchPanels = [...document.querySelectorAll('.merch-subpanel')];

      activateMerchTab = (tab, moveFocus = false) => {
        merchTabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        merchPanels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        if (moveFocus) tab.focus();
      };

      merchTabs.forEach((tab) => tab.addEventListener('click', () => activateMerchTab(tab)));
      merchTablist.addEventListener('keydown', (event) => {
        const currentIndex = merchTabs.indexOf(document.activeElement);
        if (currentIndex < 0 || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % merchTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + merchTabs.length) % merchTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = merchTabs.length - 1;
        activateMerchTab(merchTabs[nextIndex], true);
      });
    }

    /* About page "original paintings and prints" link jumps to the prints sub tab */
    const aboutPrintsLink = document.getElementById('about-prints-link');
    if (aboutPrintsLink) {
      aboutPrintsLink.addEventListener('click', (event) => {
        event.preventDefault();
        const merchTab = document.getElementById('tab-merch');
        if (merchTab) activateTab(merchTab);
        if (activateMerchTab) {
          const printsTab = document.getElementById('merch-tab-prints');
          if (printsTab) activateMerchTab(printsTab);
        }
        requestAnimationFrame(() => {
          const printsPanel = document.getElementById('merch-panel-prints');
          if (printsPanel) printsPanel.scrollIntoView({ block: 'start' });
        });
      });
    }

    /* Aftercare sub tabs */
    const aftercareTablist = document.querySelector('.aftercare-tabs');
    if (aftercareTablist) {
      const aftercareTabs = [...aftercareTablist.querySelectorAll('[role="tab"]')];
      const aftercarePanels = [...document.querySelectorAll('.aftercare-subpanel')];

      const activateAftercareTab = (tab, moveFocus = false) => {
        aftercareTabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        aftercarePanels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        if (moveFocus) tab.focus();
      };

      aftercareTabs.forEach((tab) => tab.addEventListener('click', () => activateAftercareTab(tab)));
      aftercareTablist.addEventListener('keydown', (event) => {
        const currentIndex = aftercareTabs.indexOf(document.activeElement);
        if (currentIndex < 0 || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % aftercareTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + aftercareTabs.length) % aftercareTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = aftercareTabs.length - 1;
        activateAftercareTab(aftercareTabs[nextIndex], true);
      });
    }

    /* Portfolio carousel */
    const carousel = document.querySelector('.slideshow');
    if (carousel) {
      const slides = [...carousel.querySelectorAll('.work-slide')];
      const dots = [...carousel.querySelectorAll('.slide-dot')];
      const count = carousel.querySelector('.slide-count');
      let current = 0;
      let touchStartX = null;

      const showSlide = (next) => {
        current = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        if (count) count.textContent = `${current + 1} of ${slides.length}`;
      };

      const prev = carousel.querySelector('.slide-prev');
      const nextBtn = carousel.querySelector('.slide-next');
      if (prev) prev.addEventListener('click', () => showSlide(current - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => showSlide(current + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(current - 1);
        if (event.key === 'ArrowRight') showSlide(current + 1);
      });

      carousel.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 42) return;
        showSlide(current + (distance < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* Deep link support: /?tab=portfolio etc, used by the tab links on shop pages */
    try {
      const wanted = new URLSearchParams(window.location.search).get('tab');
      if (wanted) {
        const target = document.getElementById('tab-' + wanted);
        if (target && tabs.indexOf(target) >= 0) activateTab(target);
      }
    } catch (e) { /* URL parsing unavailable */ }
  }

  /* ---------- Mailing list popup ---------- */
  const overlay = document.getElementById('mailing-modal');
  if (overlay) {
    const form = document.getElementById('mailing-modal-form');
    const formWrap = document.getElementById('mailing-modal-body');
    const thanks = document.getElementById('mailing-modal-thanks');
    const closeBtn = document.getElementById('mailing-modal-close');
    const doneBtn = document.getElementById('mailing-modal-done');
    const emailInput = document.getElementById('mce-EMAIL-pop');
    const KEY = 'af-mailing-popup';
    const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

    const remember = (value) => {
      try { localStorage.setItem(KEY, value); } catch (e) { /* storage unavailable */ }
    };

    const openModal = () => {
      overlay.hidden = false;
      document.body.classList.add('modal-open');
      if (emailInput) window.setTimeout(() => emailInput.focus(), 60);
    };

    const closeModal = (subscribed) => {
      overlay.hidden = true;
      document.body.classList.remove('modal-open');
      remember(subscribed ? 'done' : String(Date.now()));
    };

    if (closeBtn) closeBtn.addEventListener('click', () => closeModal(false));
    if (doneBtn) doneBtn.addEventListener('click', () => closeModal(true));
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeModal(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) closeModal(false);
    });
    if (form) form.addEventListener('submit', () => {
      if (formWrap) formWrap.hidden = true;
      if (thanks) thanks.hidden = false;
      remember('done');
    });

    let show = true;
    try {
      const seen = localStorage.getItem(KEY);
      show = !seen || (seen !== 'done' && Date.now() - Number(seen) > THIRTY_DAYS);
    } catch (e) { show = true; }
    if (show) window.setTimeout(openModal, 1500);
  }

  /* ---------- Painting lightbox ---------- */
  const lb = document.getElementById('painting-lightbox');
  if (lb) {
    const lbImg = lb.querySelector('.lightbox-img');
    const lbCap = lb.querySelector('.lightbox-caption');
    const closeLb = () => {
      lb.hidden = true;
      if (lbImg) lbImg.removeAttribute('src');
      document.body.classList.remove('lightbox-open');
    };
    document.querySelectorAll('button.painting-art-link').forEach((btn) => {
      btn.addEventListener('click', () => {
        const img = btn.querySelector('img');
        if (lbImg) {
          lbImg.src = btn.getAttribute('data-full');
          lbImg.alt = (img && img.getAttribute('alt')) || '';
        }
        const card = btn.closest('.painting-card');
        const title = card ? card.querySelector('.painting-name') : null;
        if (lbCap) lbCap.textContent = title ? title.textContent : '';
        lb.hidden = false;
        document.body.classList.add('lightbox-open');
      });
    });
    const lbClose = lb.querySelector('.lightbox-close');
    if (lbClose) lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', (e) => { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !lb.hidden) closeLb();
    });
  }
})();
